import { useState } from 'react';
import { AnchorBar, AnchorBarList, AnchorBarListItem } from '@vp/swan';
import { NavItem } from './types';

interface StickyNavProps {
    navItems: NavItem[];
}

export function StickyNav({ navItems }: StickyNavProps) {
    const [activeAnchor, setActiveAnchor] = useState();

    return (
        <AnchorBar
            data-testid="sticky-nav"
            bgc="standard"
            sticky
            onActiveAnchorChanged={setActiveAnchor}
        >
            <AnchorBarList>
                {navItems.map((item) => (
                    <AnchorBarListItem key={item.href}>
                        <a
                            href={item.href}
                            aria-current={`#${activeAnchor}` === item.href ? 'true' : undefined}
                        >
                            {item.label}
                        </a>
                    </AnchorBarListItem>
                ))}
            </AnchorBarList>
        </AnchorBar>
    );
}
